import { OfferWrapper, Provider } from 'generated/api'
import { buildSearchHistoryBlocks } from 'components/domain/search/offers/loans/builder'
import { SearchHistoryOfferCard } from 'components/domain/search/offers/loans/LoanOfferCard/SearchHistoryOfferCard'
import { SimpleOffer } from 'experiences/shared/OfferList/SimpleOffer'

interface Props {
	offers?: OfferWrapper[]
	providers?: Provider[]
	redirectToOffer: (offer: OfferWrapper) => void
}

export const OfferList = ({ offers, providers = [], redirectToOffer }: Props): JSX.Element => {
	return (
		<>
			{offers?.map((offer: OfferWrapper) => {
				if (offer.sourceType === 'loan') {
					const provider = providers.find(p => p.uuid === offer.provider)!
					const blocks = buildSearchHistoryBlocks({
						offer,
						provider,
						onClick: (): void => redirectToOffer(offer)
					})
					return <SearchHistoryOfferCard key={offer.key} {...blocks} />
				} else if (offer.sourceType === 'simple') {
					return <SimpleOffer key={offer.key} offer={offer} />
				} else {
					return <></>
				}
			})}
		</>
	)
}
